<div class="toolbar second-level-toolbar flex flex-row justify-between items-center">

  <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
    <label class="component-label"> Actions</label>
    <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
      <div class="button-container flex flex-row justify-start items-center">
        <button mat-button class="orbitax-flat-button" (click)="addFolder()"
                particleAnalytics
                analyticsCategory="file-manager-content"
                analyticsAction="Add-Folder">Add Folder
        </button>

        <div class="toolbar-separator"></div>
      </div>

      <div class="button-container flex flex-row justify-start items-center">
        <button mat-button class="orbitax-flat-button" (click)="uploadFile()"
                particleAnalytics
                analyticsCategory="file-manager-content"
                analyticsAction="Upload">Upload
        </button>
        <div class="toolbar-separator"></div>
      </div>

    </div>
  </div>

</div>
<div class="content flex flex-col">
  <div class="breadcrumb-container m-b-10 flex flex-row justify-start items-center">
    <a clas="link-color flex flex-row justify-start items-center"
       [ngClass]="{'disabled': currentLocation.parentIds.length-1<=i}"
       *ngFor="let path of currentLocation.relativePaths; let i = index;"
       (click)="navigateToFolder(i)"
       particleAnalytics
       analyticsCategory="file-manager-content"
       analyticsAction="breadcrumb"
       [analyticsName]="path"
    >
      <span>{{currentLocation.fileNames[i]}}</span>
      <mat-icon>chevron_right</mat-icon>
    </a>
  </div>
  <div class="pos-relative m-b-30">
    <div class="keno-grid-container">
      <particle-smart-grid [sourceType]="sourceType"
                           [selectableSettings]="selectableSettings">
      </particle-smart-grid>
    </div>
  </div>
</div>
